export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: '首页',
        games: '游戏',
        categories: '分类',
        about: '关于'
    },
    search: {
        placeholder: '搜索猫咪游戏...',
        suggestions: {
            game: '游戏',
            tag: '标签'
        }
    },

    // Hero Section
    hero: {
        title: '猫咪游戏',
        description: '在PlayCatGames上体验各种有趣的虚拟猫咪游戏。您可以点击或轻触来投掷玩具，拖放服装装扮角色，或使用快速反应来捕鱼和追逐奖励。',
        subtitle: '一些猫咪游戏测试您的时机掌握，让您跳跃、奔跑或攀爬，而其他游戏则专注于简单的操作，如喂食、梳理毛发或点击得分。每个游戏都设计为在浏览器中即时享受乐趣。无需安装，无需下载，只需喵一声！',
        buttons: {
            start: '开始游戏',
            browse: '浏览分类'
        },
        stats: {
            games: '免费游戏',
            categories: '游戏分类',
            free: '免费体验',
            available: '随时可玩'
        }
    },

    // Games Section
    games: {
        title: '热门猫咪游戏',
        subtitle: '发现最受欢迎的免费在线猫咪游戏，适合所有年龄段玩家',
        filters: {
            all: '全部',
            dressUp: '装扮',
            care: '护理',
            puzzle: '解谜',
            arcade: '街机',
            simulation: '模拟'
        },
        loadMore: '加载更多游戏',
        gameCategories: {
            arcade: '街机',
            simulation: '模拟',
            care: '护理',
            puzzle: '解谜',
            dressUp: '装扮'
        }
    },

    // Categories Section
    categories: {
        title: '游戏分类',
        subtitle: '每个猫咪游戏都围绕玩家最喜欢的活动而设计：装扮、照料或穿越有趣的关卡',
        browse: '浏览分类',
        featuredGames: '热门游戏',
        gameCount: '游戏',
        types: {
            dressUp: {
                name: '猫咪装扮游戏',
                description: '猫咪装扮游戏让您的创造力尽情发挥。混搭服装、添加配饰，解锁从奇幻套装到季节装备的主题造型。'
            },
            simulation: {
                name: '猫咪模拟和角色扮演',
                description: '在模拟游戏中，您将进入猫咪的爪子。漫游、探索，过着好奇小猫的生活。'
            },
            puzzle: {
                name: '猫咪管理和解谜游戏',
                description: '对于策略爱好者，猫咪解谜和管理游戏提供巧妙的转折。平衡多只猫咪，解决棘手的叠放挑战。'
            },
            arcade: {
                name: '猫咪街机和动作游戏',
                description: '快节奏的猫咪街机游戏，测试您的反应速度和敏捷性。跳跃、奔跑、捕捉，享受刺激的游戏体验。'
            }
        },
        additional: {
            title: '探索更多猫咪游戏类型',
            description: '我们的猫咪游戏收藏涵盖了每种心情和喜好：时尚游戏、宠物护理、巧妙谜题或有趣的街机奔跑。我们基于浏览器的猫咪游戏是免费、安全的，并且可以在几秒钟内开始游戏。',
            motto: '只需选择一个游戏，点击开始，让乐趣开始喵叫吧！'
        }
    },

    // About Section
    about: {
        title: '关于 PlayCatGames',
        description: [
            'PlayCatGames 是您探索精彩猫咪游戏世界的终极目的地。我们精心策划了一系列免费的在线猫咪主题游戏，适合所有年龄段的玩家。',
            '从可爱的装扮游戏到刺激的街机冒险，从温馨的护理模拟到巧妙的解谜挑战，我们的游戏收藏涵盖了猫咪爱好者可能想要的一切。所有游戏都经过精心挑选，确保提供最佳的游戏体验。',
            '我们相信游戏应该是即时的、有趣的和易于访问的。这就是为什么我们所有的游戏都可以直接在您的浏览器中运行，无需下载或安装任何软件。只需点击并开始游戏！'
        ],
        features: {
            free: '100% 免费游戏',
            mobile: '移动端友好',
            instant: '即时游戏',
            safe: '安全可靠'
        },
        cards: {
            gamesCount: '50+ 游戏',
            gamesUpdate: '持续更新',
            rating: '4.8/5 评分',
            recommended: '玩家推荐'
        },
        faq: {
            title: '常见问题',
            questions: {
                free: {
                    q: '这些游戏真的免费吗？',
                    a: '是的！我们所有的猫咪游戏都是完全免费的。您无需支付任何费用即可享受所有游戏内容。'
                },
                download: {
                    q: '我需要下载任何软件吗？',
                    a: '不需要！所有游戏都可以直接在您的浏览器中运行。只需点击游戏即可开始游玩，无需下载或安装。'
                },
                age: {
                    q: '这些游戏适合什么年龄段？',
                    a: '我们的猫咪游戏适合所有年龄段的玩家。从简单的装扮游戏到具有挑战性的解谜游戏，每个人都能找到适合自己的游戏。'
                },
                mobile: {
                    q: '游戏支持移动设备吗？',
                    a: '是的！我们所有的游戏都经过优化，可以在PC、平板电脑和手机上完美运行。您可以随时随地享受游戏乐趣。'
                },
                updates: {
                    q: '你们会添加新游戏吗？',
                    a: '当然！我们定期更新游戏库，添加新的有趣猫咪游戏。请经常回来查看最新的游戏内容。'
                }
            }
        }
    },

    // Footer
    footer: {
        description: '您的免费在线猫咪游戏集合destination。发现、游玩并享受数十款精彩的猫咪主题游戏。',
        quickLinks: '快速链接',
        gameCategories: '游戏分类',
        support: '支持',
        links: {
            popularGames: '热门游戏',
            latestGames: '最新游戏',
            recommendedGames: '推荐游戏',
            faq: '常见问题',
            contact: '联系我们',
            feedback: '意见反馈',
            privacy: '隐私政策',
            terms: '使用条款',
            cookies: 'Cookie 政策',
            sitemap: '网站地图'
        },
        copyright: '版权所有。',
        disclaimer: '所有游戏内容来源于互联网，仅供娱乐学习使用。如有版权问题请联系我们。',
        backToTop: '回到顶部',
        friendlyLinks: '友情链接'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: '帮助小猫咪捕捉飞鸟，展现你的反应速度',
            catPizza: '经营一家猫咪比萨店，为顾客制作美味比萨',
            funnyKittyCare: '照顾可爱的小猫咪，喂食、洗澡和游戏',
            catsDrop: '叠猫咪游戏，测试你的平衡和策略技巧',
            catpad: '可爱的猫咪平台跳跃游戏',
            funnyKittyDressup: '为可爱的小猫咪打扮，选择各种服装和配饰',
            kittyCats: '与多只可爱猫咪互动的休闲游戏',
            dualCat: '控制两只猫咪同时闯关的挑战游戏',
            funnyKittyHaircut: '为小猫咪设计时尚发型的美容游戏',
            catCoffeeShop: '经营猫咪咖啡店，制作美味饮品'
        },
        categories: {
            puzzle: '解谜',
            simulation: '模拟',
            casual: '休闲',
            action: '动作',
            adventure: '冒险',
            strategy: '策略',
            sports: '体育',
            racing: '竞速',
            dressup: '装扮',
            care: '护理'
        },
        tags: {
            cute: '可爱',
            anime: '二次元',
            dark: '暗黑',
            funny: '搞笑',
            educational: '教育',
            multiplayer: '多人',
            relaxing: '放松',
            challenging: '挑战',
            colorful: '色彩丰富',
            simple: '简单',
            complex: '复杂',
            family: '家庭友好',
            kids: '儿童',
            adult: '成人'
        }
    },

    // Common
    common: {
        loading: '加载中...',
        error: '出错了',
        retry: '重试',
        play: '开始游戏',
        language: '语言',
        backToHome: '返回首页'
    },

    // Game Play Page
    gamePage: {
        plays: '次游玩',
        share: '分享',
        enterFullscreen: '全屏',
        exitFullscreen: '退出全屏',
        loadingGame: '游戏加载中...',
        reload: '重新加载',
        linkCopied: '链接已复制到剪贴板',
        notFound: {
            title: '游戏未找到',
            message: '抱歉，我们找不到这个游戏。它可能已被移除或链接有误。'
        },
        loadError: {
            title: '游戏加载失败',
            message: '无法加载游戏内容，请检查网络连接或稍后再试。'
        }
    },

    // Legal Pages
    legal: {
        privacy: {
            title: '隐私政策',
            lastUpdated: '最后更新',
            sections: {
                overview: {
                    title: '概述',
                    content: 'PlayCatGames（"我们"、"我们的"或"本网站"）致力于保护您的隐私。本隐私政策说明了我们如何收集、使用和保护您在使用我们网站时提供的信息。'
                },
                dataCollection: {
                    title: '信息收集',
                    intro: '我们可能收集以下类型的信息：',
                    items: [
                        '自动收集的信息：包括您的IP地址、浏览器类型、操作系统、访问时间和引用页面',
                        'Cookies和类似技术：用于改善您的浏览体验和分析网站使用情况',
                        '语言偏好：用于提供个性化的多语言体验',
                        '游戏使用数据：包括游戏偏好和使用统计（匿名化处理）'
                    ]
                },
                dataUsage: {
                    title: '信息使用',
                    intro: '我们使用收集的信息用于：',
                    items: [
                        '提供和维护我们的服务',
                        '改善用户体验和网站功能',
                        '分析网站使用模式',
                        '提供技术支持',
                        '遵守法律义务'
                    ]
                },
                cookies: {
                    title: 'Cookies',
                    content: '我们使用cookies来增强您的浏览体验。Cookies是存储在您设备上的小文本文件，帮助我们记住您的偏好设置。您可以通过浏览器设置控制cookies的使用。'
                },
                thirdParty: {
                    title: '第三方服务',
                    content: '我们的网站可能包含指向第三方网站的链接。我们不对这些网站的隐私做法负责。我们建议您查看您访问的每个网站的隐私政策。'
                },
                security: {
                    title: '数据安全',
                    content: '我们采取合理的安全措施来保护您的个人信息免受未经授权的访问、使用或披露。但是，请注意，没有任何互联网传输方法是100%安全的。'
                },
                children: {
                    title: '儿童隐私',
                    content: '我们的服务面向所有年龄段的用户。我们不会故意收集13岁以下儿童的个人信息。如果您是家长或监护人，发现您的孩子向我们提供了个人信息，请联系我们。'
                },
                changes: {
                    title: '政策更新',
                    content: '我们可能会不时更新本隐私政策。任何更改将在此页面上发布，并更新"最后更新"日期。我们建议您定期查看本政策。'
                },
                contact: {
                    title: '联系我们',
                    content: '如果您对本隐私政策有任何疑问或关注，请通过以下方式联系我们：',
                    email: '邮箱'
                }
            }
        },
        terms: {
            title: '使用条款',
            lastUpdated: '最后更新',
            sections: {
                acceptance: {
                    title: '条款接受',
                    content: '通过访问和使用PlayCatGames网站，您同意遵守这些使用条款。如果您不同意这些条款，请不要使用我们的服务。'
                },
                services: {
                    title: '服务描述',
                    content: 'PlayCatGames提供免费的在线猫咪主题游戏。我们的服务包括游戏内容、网站功能和相关服务，这些都通过我们的网站提供。'
                },
                userConduct: {
                    title: '用户行为',
                    intro: '使用我们的服务时，您同意不会：',
                    items: [
                        '从事任何非法或有害的活动',
                        '干扰或破坏网站的正常运行',
                        '尝试获取未经授权的访问权限',
                        '上传或传输有害内容',
                        '侵犯他人的权利或隐私'
                    ]
                },
                intellectualProperty: {
                    title: '知识产权',
                    content: '网站上的所有内容，包括但不限于文本、图像、游戏和设计，均受版权和其他知识产权法律保护。未经明确许可，您不得复制、分发或修改任何内容。'
                },
                disclaimer: {
                    title: '免责声明',
                    content: '我们的服务按"现状"提供，不提供任何明示或暗示的保证。我们不保证服务的准确性、可靠性或可用性。'
                },
                liability: {
                    title: '责任限制',
                    content: '在法律允许的最大范围内，PlayCatGames不对因使用我们的服务而产生的任何直接、间接、偶然或后果性损害承担责任。'
                },
                modifications: {
                    title: '条款修改',
                    content: '我们保留随时修改这些使用条款的权利。修改后的条款将在网站上发布，并立即生效。继续使用服务表示您接受修改后的条款。'
                },
                termination: {
                    title: '服务终止',
                    content: '我们保留在任何时候，因任何原因，暂停或终止您对服务的访问的权利，无需事先通知。'
                },
                governing: {
                    title: '适用法律',
                    content: '这些使用条款受中华人民共和国法律管辖。任何争议应通过友好协商解决，协商不成的，提交仲裁解决。'
                },
                contact: {
                    title: '联系我们',
                    content: '如果您对这些使用条款有任何疑问，请联系我们：',
                    email: '邮箱'
                }
            }
        },
        cookies: {
            title: 'Cookie政策',
            lastUpdated: '最后更新',
            sections: {
                what: {
                    title: '什么是Cookies',
                    content: 'Cookies是当您访问网站时存储在您的计算机或移动设备上的小文本文件。它们被广泛用于使网站工作或更高效地工作，以及向网站所有者提供信息。'
                },
                usage: {
                    title: '我们如何使用Cookies',
                    intro: '我们使用cookies来：',
                    items: [
                        '记住您的语言偏好设置',
                        '分析网站流量和使用模式',
                        '改善网站性能和用户体验',
                        '提供个性化内容',
                        '确保网站安全'
                    ]
                },
                types: {
                    title: 'Cookie类型',
                    essential: {
                        title: '必要Cookies',
                        content: '这些cookies对网站的运行是必需的，无法禁用。它们通常仅在响应您的操作时设置，例如设置隐私偏好、登录或填写表单。'
                    },
                    functional: {
                        title: '功能性Cookies',
                        content: '这些cookies使网站能够提供增强的功能和个性化。它们可能由我们或我们已将其服务添加到页面的第三方提供商设置。'
                    },
                    analytics: {
                        title: '分析Cookies',
                        content: '这些cookies帮助我们了解访问者如何与网站互动。它们提供有关访问者数量、他们在网站上花费的时间以及他们访问的页面的信息。'
                    }
                },
                control: {
                    title: '控制Cookies',
                    content: '您可以通过浏览器设置控制和删除cookies。但是，请注意，禁用某些cookies可能会影响网站的功能和您的用户体验。'
                },
                thirdParty: {
                    title: '第三方Cookies',
                    content: '我们的网站可能包含来自第三方服务的cookies，如分析工具或社交媒体插件。这些第三方有自己的隐私政策，我们建议您查看它们。'
                },
                updates: {
                    title: '政策更新',
                    content: '我们可能会不时更新此Cookie政策。任何更改将在此页面上发布，并更新"最后更新"日期。'
                },
                contact: {
                    title: '联系我们',
                    content: '如果您对我们的Cookie使用有任何疑问，请联系我们：',
                    email: '邮箱'
                }
            }
        }
    },

    // Sitemap
    sitemap: {
        title: '网站地图',
        description: '查找PlayCatGames网站上的所有页面和内容',
        sections: {
            main: {
                title: '主要页面',
                home: '首页',
                games: '游戏',
                categories: '分类',
                about: '关于我们'
            },
            categories: {
                title: '游戏分类',
                dressUp: '装扮游戏',
                care: '护理游戏',
                puzzle: '解谜游戏',
                arcade: '街机游戏',
                simulation: '模拟游戏'
            },
            games: {
                title: '热门游戏'
            },
            support: {
                title: '支持',
                faq: '常见问题',
                contact: '联系我们',
                feedback: '意见反馈'
            },
            legal: {
                title: '法律页面',
                privacy: '隐私政策',
                terms: '使用条款',
                cookies: 'Cookie政策'
            },
            languages: {
                title: '语言支持'
            }
        },
        info: {
            title: '关于本网站',
            description: 'PlayCatGames提供丰富的免费在线猫咪游戏，支持多种语言，为全球玩家提供最佳的游戏体验。所有游戏都经过精心挑选，确保安全、有趣且适合所有年龄段。'
        }
    }
}